module.exports = __webpack_public_path__ + "statics/img/4-6.d7a85b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/4-6.png
// module id = Ih3D
// module chunks = 1